/**
 * Bike Bell – Main entry point
 *
 * Built via theme's Gulp pipeline (manifest.json).
 */
(function ($) {
    'use strict';

    if ($('body').hasClass('bikebell')) {
        window.ys.bikebell = new BikeBell();
    }
}).bind(window)(jQuery);
